import styled from "styled-components";

export const StyledConnectBankAccountBoxWrapper = styled.div`
  padding: 2.4rem;
  border: 1px solid #f0f0f0;
  background-color: #fff;
  border-radius: 5px;
`;
export const StyledConnectBankAccountBoxContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  .info-text {
    color: #1c1726;
    font-size: 1.4rem;
  }
`;
export const StyledAccountDetailsBoxWrapper = styled.div`
  padding: 1rem;
  display: flex;
  gap: 2.4rem;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #f0f0f0;
  background-color: #fff;
  border-radius: 5px;

  @media (max-width: 670px) {
    flex-direction: column;
    align-items: center;
    padding: 0;
    text-align: center;
  }
`;
export const StyledBankIconAndAccountDetailsWrapper = styled.div`
  display: flex;
  gap: 9px;
  align-items: center;

  @media (max-width: 670px) {
    flex-direction: column;
    align-items: initial;
  }
`;
export const StyledPersonalAccountDetailsWrapper = styled.div`
  .bold-text {
    font-size: 1.4rem;
    font-weight: 600;
  }
`;
